//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "page-search-header",
    data() {
        return {
            columns: [],
            loading: false,
            showProjectPicker: false,
            showProjectStagesPicker: false,
            showRoomStructureNamePicker: false,
            showChamberNamePicker: false,
            searchInput: {
                projectId: 0,
                projectStages: null,
                roomStructureName: null,
                chamberName: null,
                roomNumber: null,
            },
            projectStages: [],
            loudongs: [],
            danyuans: [],
        }
    },
    props: {},
    computed: {
        userProjects() {
            return this.$store.state.member.userProjects
        }
    },
    methods: {
        handleSearch() {
            this.$emit('handleSearch', this.searchInput)
        },
        handleReset() {
            this.searchInput = {
                projectId: 0,
                projectStages: null,
                roomStructureName: null,
                chamberName: null,
                roomNumber: null,
            };
            this.handleSearch();
        },
        onConfirm(value, index) {
            console.log(value, index)
            this.searchInput.projectId = value.id;
            this.searchInput.projectName = value.name;
            this.showProjectPicker = false;
            this.getProjectStages();
            this.getLouDongs();
        },

        getProjectStages() {
            let page = {
                projectId: this.searchInput.projectId
            }
            this.loading = true;
            abp.ajax.get('/api/services/app/Project/GetProjectStages', {params: page}).then(res => {
                this.projectStages = [];
                this.projectStages.push(...res.data.result.items);
                this.projectStages.forEach(item => {
                    item.children = null
                })
            }).finally(() => {
                this.loading = false;
            });
        },
        onConfirmProjectStages(value, index) {
            this.searchInput.projectStages = value.key;
            this.showProjectStagesPicker = false;
            this.getLouDongs()
        },

        getLouDongs() {
            this.loading = true;
            let page = {
                projectId: this.searchInput.projectId,
                fenqiName: this.searchInput.projectStages,
            }
            abp.ajax.get('/api/services/app/Project/GetLouDong', {params: page}).then(res => {
                this.loudongs = [];
                this.loudongs.push(...res.data.result);
                this.loudongs.forEach(item => {
                    item.children = null
                })
            }).finally(() => {
                this.loading = false;
            });
        },
        onConfirmRoomStructureName(value, index) {
            this.searchInput.roomStructureName = value.key;
            this.showRoomStructureNamePicker = false;
            this.getDanYuan();
        },

        getDanYuan() {
            let page = {
                projectId: this.searchInput.projectId,
                fenqi: this.searchInput.projectStages,
                loudongName: this.searchInput.roomStructureName
            };
            abp.ajax.get('/api/services/app/Project/GetDanYuanList', {params: page}).then(res => {
                this.danyuans = [];
                this.danyuans.push(...res.data.result);
                this.danyuans.forEach(item => {
                    item.children = null
                })
            });
        },
        onConfirmChamberName(value, index) {
            this.searchInput.chamberName = value.key;
            this.showChamberNamePicker = false;
        }


    },
    created() {
    }
}
